const List = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.59998 5C4.15226 5 4.59998 5.44772 4.59998 6V6.0128C4.59998 6.56509 4.15226 7.0128 3.59998 7.0128C3.04769 7.0128 2.59998 6.56509 2.59998 6.0128V6C2.59998 5.44772 3.04769 5 3.59998 5ZM7.71998 6C7.71998 5.44772 8.16769 5 8.71998 5H21.6C22.1523 5 22.6 5.44772 22.6 6C22.6 6.55228 22.1523 7 21.6 7H8.71998C8.16769 7 7.71998 6.55228 7.71998 6ZM3.59998 11.48C4.15226 11.48 4.59998 11.9277 4.59998 12.48V12.4928C4.59998 13.0451 4.15226 13.4928 3.59998 13.4928C3.04769 13.4928 2.59998 13.0451 2.59998 12.4928V12.48C2.59998 11.9277 3.04769 11.48 3.59998 11.48ZM7.71998 12.48C7.71998 11.9277 8.16769 11.48 8.71998 11.48H21.6C22.1523 11.48 22.6 11.9277 22.6 12.48C22.6 13.0323 22.1523 13.48 21.6 13.48H8.71998C8.16769 13.48 7.71998 13.0323 7.71998 12.48ZM3.59998 17.96C4.15226 17.96 4.59998 18.4077 4.59998 18.96V18.9728C4.59998 19.5251 4.15226 19.9728 3.59998 19.9728C3.04769 19.9728 2.59998 19.5251 2.59998 18.9728V18.96C2.59998 18.4077 3.04769 17.96 3.59998 17.96ZM7.71998 18.96C7.71998 18.4077 8.16769 17.96 8.71998 17.96H21.6C22.1523 17.96 22.6 18.4077 22.6 18.96C22.6 19.5123 22.1523 19.96 21.6 19.96H8.71998C8.16769 19.96 7.71998 19.5123 7.71998 18.96Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default List;
